import React from 'react';
import { Link } from 'react-router-dom';

const links = [
    { to: '/form',                label: 'Submit Manuscript' },
    { to: '/author-guidelines',   label: 'Author Guidelines' },
    { to: '/current-issue',       label: 'Current Issue' },
    { to: '/archives',            label: 'Archives' },
    { to: '/editorial-leadership',label: 'Editorial Leadership' },
];

const QuickLinksCard = () => (
    <div className="sidebar-card">
        <h3 className="sidebar-card__title">Quick Links</h3>
        <ul className="sidebar-links">
            {links.map(({ to, label }) => (
                <li className="sidebar-links__item" key={to}>
                    <Link to={to} className="sidebar-links__anchor">{label}</Link>
                </li>
            ))}
        </ul>
    </div>
);

export default QuickLinksCard;
